/**
 * Round a number with half values up.
 *
 * @param value - The number to round.
 *
 * @returns The rounded number.
 */
export var halfUp = function halfUp(value) {
  return Math.round(value);
};